export const COMPANY_INFO = {
  name: 'INTEGRITZ TECHNOLOGIES PRIVATE LIMITED',
  email: 'athish@integritz.in',
  phone: '+91 8095998426',
  address: '942/3, 2nd Main, 4th Block, Rajajinagar, Bangalore - 560010',
  businessHours: {
    weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
    saturday: 'Saturday: 9:00 AM - 1:00 PM'
  }
};

export const API_CONFIG = {
  timeout: 30000,
  retryAttempts: 3
};
